import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";

const MetricBox = ({ label, value, color }) => (
  <div className="bd-metric-box">
    <div className="bd-metric-label" style={color ? { color } : {}}>{label}</div>
    <div className="bd-metric-value" style={color ? { color } : {}}>{value ?? "—"}</div>
  </div>
);

const ProcessFlow = ({ data = {}, isLoading = false }) => (
  <div className="bd-left-col">
    {/* RECEIVING */}
    <DashboardCard title="Receiving">
      <div className="bd-receiving-row">
        <MetricBox label="CASE ENTERED"  value={data?.total_cases_entered?.toLocaleString() ?? 0}  color="#ee7225" />
        <MetricBox label="CASE ACCEPTED" value={data?.total_cases_accepted?.toLocaleString() ?? 0} color="#25aa91" />
        <MetricBox label="CASE REJECTED" value={data?.total_cases_rejected?.toLocaleString() ?? 0} color="#e53935" />
      </div>
    </DashboardCard>

    {/* PROCESSING FLOW */}
    <DashboardCard title="Processing Flow">
      <div className="bd-processing-grid">
        <MetricBox label="Case Sorted"           value={`${data?.total_cases_sorted?.toLocaleString() ?? "0"} kg`} />
        <MetricBox label="Case Processed"        value={`${data?.total_cases_processed?.toLocaleString() ?? "0"} kg`} />
        <MetricBox label="Kg Night Taken Off"    value={`${data?.kg_night_taken_off?.toLocaleString() ?? "0"} kg`} />
        <MetricBox label="Boxes Packed Fruit"    value={`${data?.boxes_packed_fruit?.toLocaleString() ?? "0"} kg`} />
        <MetricBox label="Boxes Packed (Rework)" value={`${data?.boxes_packed_rework?.toLocaleString() ?? "0"} kg`} />
        <MetricBox label="Boxes Packed Paste"    value={`${data?.boxes_packed_paste?.toLocaleString() ?? "0"} kg`} />
      </div>
    </DashboardCard>
  </div>
);

export default ProcessFlow;
